import { render, staticRenderFns } from "./faceModal.vue?vue&type=template&id=15f47816&scoped=true&"
import script from "./faceModal.vue?vue&type=script&lang=js&"
export * from "./faceModal.vue?vue&type=script&lang=js&"
import style0 from "./faceModal.vue?vue&type=style&index=0&id=15f47816&lang=scss&scoped=true&"
import style1 from "./faceModal.vue?vue&type=style&index=1&id=15f47816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f47816",
  null
  
)

export default component.exports